import * as z$1 from "zod/v4";
//#region src/account-organization-context.ts
const ACCOUNT_ORGANIZATION_CONTEXT_PATH = "/v1/account/organization-context";
const organizationSummarySchema = z$1.strictObject({
	id: z$1.string().refine((value) => value.trim().length > 0),
	name: z$1.string().refine((value) => value.trim().length > 0),
	slug: z$1.string().refine((value) => value.trim().length > 0),
	logo: z$1.string().nullable().optional(),
	isPersonal: z$1.boolean().optional()
});
const accountOrganizationContextSchema = z$1.strictObject({
	account: z$1.strictObject({
		email: z$1.string().nullable(),
		image: z$1.string().nullable(),
		name: z$1.string().nullable()
	}),
	currentUserId: z$1.string().trim().min(1),
	organizations: z$1.array(organizationSummarySchema),
	defaultOrganizationId: z$1.string().min(1).nullable()
}).refine((value) => value.defaultOrganizationId === null ? value.organizations.length === 0 : value.organizations.some((organization) => organization.id === value.defaultOrganizationId));
//#endregion
export { ACCOUNT_ORGANIZATION_CONTEXT_PATH, accountOrganizationContextSchema, organizationSummarySchema };

//# sourceMappingURL=account-organization-context.js.map